<template>
    <div class="search-panel__button-item">
        <button :data-url="link.href"
                @click="goToParam(link.href)"
                class="button button_theme_color ym-param"
        >
            Смотреть&nbsp;
            <span class="search-panel__filter-count">
                {{ link.text }}
            </span>
        </button>
    </div>
</template>

<script>

export default {
    props: ['link', 'windowWidth'],

    methods: {
        goToParam(url) {
            if (window.ym) {
                window.ym(87230151, 'reachGoal', 'podbor');
            }

            window.open(url, '_blank');
        }
    }
};
</script>
